import React from "react";

function fixMultipleH1(html: string): string {
  let firstOpenSeen = false;
  let inFirstH1 = false;
  return html.replace(/<(\/?)h1\b([^>]*)>/gi, (match, slash, attrs) => {
    if (slash === "") {
      if (!firstOpenSeen) {
        firstOpenSeen = true;
        inFirstH1 = true;
        return `<h1${attrs}>`;
      }
      return `<h2${attrs}>`;
    }
    if (inFirstH1) {
      inFirstH1 = false;
      return `</h1>`;
    }
    return `</h2>`;
  });
}

interface Props {
  html: string;
}

export class TildaContent extends React.Component<Props> {
  componentDidMount() {
    if (document.querySelector("video")) {
      document.querySelectorAll("video").forEach((item) => {
        item.removeAttribute("controls");
      });
    }
    if (document.querySelector('div[data-videolazy-type*="youtube"]')) {
      document.querySelectorAll('div[data-videolazy-type*="youtube"]').forEach((item: Element) => {
        const el = item as HTMLElement;
        el.innerHTML = `<div class="tilda-video-container"><iframe src="https://www.youtube.com/embed/${el.dataset.videolazyId}" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe></div>`;
      });
    }
    if (document.querySelector(".tn-atom__videoiframe")) {
      document.querySelectorAll(".tn-atom__videoiframe").forEach((item: Element) => {
        const el = item as HTMLElement;
        el.innerHTML = `<div class="tilda-video-container"><iframe src="https://www.youtube.com/embed/${el.dataset.youtubeid}" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe></div>`;
      });
    }
    if (document.querySelector(".t849__accordion")) {
      document.querySelectorAll(".t849__accordion").forEach((item) => {
        item.addEventListener("click", function (this: HTMLElement, e) {
          e.preventDefault();
          document.querySelectorAll(".t849__content").forEach((el: Element) => {
            (el as HTMLElement).style.display = "none";
          });
          const content = (this as HTMLElement).querySelector(".t849__content") as HTMLElement;
          if (content) {
            content.style.display = content.style.display === "block" ? "none" : "block";
          }
        });
      });
    }
    if (document.querySelector("div[data-image-width]")) {
      document.querySelectorAll("div[data-image-width]").forEach((item: Element) => {
        const el = item as HTMLElement;
        if (el.dataset.imageWidth) {
          el.style.width = el.dataset.imageWidth + "px";
          el.style.backgroundSize = "contain";
        }
        if (el.dataset.imageHeight) {
          el.style.height = el.dataset.imageHeight + "px";
        }
      });
    }
  }

  render() {
    const html = fixMultipleH1(
      this.props.html
        .replaceAll("<video", "<video autoplay loop muted playsinline")
        .replaceAll("t_onReady", "")
    );
    return <div dangerouslySetInnerHTML={{ __html: html }} />;
  }
}
